__turbopack_context__.v({
  "bottomRow": "headerLayoutMobile-module-scss-module__jei6sW__bottomRow",
  "expandedContent": "headerLayoutMobile-module-scss-module__jei6sW__expandedContent",
  "expandedHeader": "headerLayoutMobile-module-scss-module__jei6sW__expandedHeader",
  "fullSpace": "headerLayoutMobile-module-scss-module__jei6sW__fullSpace",
  "headerContainer": "headerLayoutMobile-module-scss-module__jei6sW__headerContainer",
  "menuGridItem": "headerLayoutMobile-module-scss-module__jei6sW__menuGridItem",
  "topRow": "headerLayoutMobile-module-scss-module__jei6sW__topRow",
});
